import Loadable from '../../components/loadable';

const ManageEventCancellationReasonsModal = Loadable({
  loader: () => import('../../pages/events/manage_event_cancellation_reasons_modal'),
  type: 'modal',
});

angular
  .module('gym')
  .value('ManageEventCancellationReasonsModal', ManageEventCancellationReasonsModal);
